import { useMediaQuery } from "@mui/material";
import { useIsClient } from "@uidotdev/usehooks";
import {
  FlexContainer,
  PlayIconStyled,
  SectionContainer,
  TextStyled,
} from "../styles";
import { ReactPlayerStyled } from "./styles";

function CompanyExtras(props) {
  const { companyDetail } = props || {};

  const isDesktop = useMediaQuery("(min-width: 1280px)");
  const isTablet = useMediaQuery("(min-width: 640px)");
  const isClient = useIsClient();

  // Variable to sort the company detail by ID
  const arrangedCompanyDetail = [...companyDetail]?.sort((a, b) => {
    // Convert string IDs from company detail to numeric format
    return parseInt(a?.id) - parseInt(b?.id);
  });

  return isClient ? (
    <SectionContainer aria-label="company extras section">
      <FlexContainer flexDirection={"column"} rowGap={4}>
        {arrangedCompanyDetail?.map((company, index) => {
          const { title, vimeoId } = company || {};
          return (
            <div key={index}>
              <TextStyled
                variant="h2"
                fontSize="1.25rem"
                fontWeight={700}
                aria-label="company extras section title"
                color={"#000"}
                marginBottom={"1.5rem"}
              >
                {title}
              </TextStyled>
              <FlexContainer justifyContent={"center"} alignItems={"center"}>
                <ReactPlayerStyled
                  url={`https://vimeo.com/${vimeoId}`}
                  playing={true}
                  loop={false}
                  controls={true}
                  light={true}
                  playIcon={<PlayIconStyled />}
                  style={{
                    borderRadius: "1rem",
                  }}
                  width={isDesktop ? 640 : isTablet ? 480 : 320}
                  height={isDesktop ? 360 : isTablet ? 270 : 180}
                />
              </FlexContainer>
            </div>
          );
        })}
      </FlexContainer>
    </SectionContainer>
  ) : null;
}

export default CompanyExtras;
